import Store from '@app/store';
import Actions from '@app/action';

export const snowplowInit = () => {
  if (!window.__snowplow__) {
    return;
  }

  const baseConfig = {
    bufferSize: 1,
    post: true,
    encodeBase64: false,
    respectDoNotTrack: true,
    userFingerprint: false,
    appId: 'transfer_core',
    platform: 'web',
  };

  window.__snowplow__('newTracker', 'co', window.__snowplow__.collector, {
    ...baseConfig,
    contexts: {
      webPage: true,
    },
    cookieName: '_wt_snowplow',
    discoverRootDomain: true,
  });

  window.__snowplow__(
    'newTracker',
    'ad_impressions',
    window.__snowplow__.collector,
    baseConfig
  );

  if (
    window.__session__ &&
    window.__session__.user &&
    window.__session__.user.id
  ) {
    window.__snowplow__('setUserId', window.__session__.user.id);
  }

  window.__snowplow__('enableLinkClickTracking:co');
  window.__snowplow__('enableActivityTracking:co', 10, 15); // 10s before the first ping, then an interval of 15s

  try {
    window.__snowplow__(function() {
      Store.dispatch(
        Actions.Session.setDomainUserId(this.co.getDomainUserInfo()[1])
      );
    });
  } catch (e) {
    /* do nothing */
  }
};

snowplowInit();
